import React, { useEffect, useState } from 'react';
import './App.css';
import './TooltipForm.css';
import './Windows.css';
import './MacOS.css';
import './Linux.css';
import './Unknown.css';
import './index.css';
import { Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Card from './card/Card';
import Login from './login/Login';
import Registration from './login/Registration';
import Logout from './login/Logout';
import { LanguageProvider } from './detectlanguage/LanguageContext';
import AutoLogout from './login/AutoLogout';
import AutoClearLocalStorage from './login/AutoClearLocalStorage';
import { AuthProvider } from './login/AuthContext';
import ProtectedRoute from './login/ProtectedRoute';
import Basicinformation from './Basicinformation';
import Yourprofession from './Yourprofession';
import Locationwisepopulation from './Locationwisepopulation';
import Enhancetransparency from './Enhancetransparency';
import { detectOS } from './components/osDetection'; //detectOS system
import Home from './frontend/home/Index';  // frontend page
import Organizationregister from './backend/organization/Organizationregister';
import Dashboard from './backend/admin/dashboard/Dashboard';


function App() {
  // osDetection function start
  const [os, setOs] = useState('unknown');
  useEffect(() => {
    const detectedOs = detectOS();
    setOs(detectedOs);
  }, []);
  // osDetection function End
  return (
    <AuthProvider>
      <LanguageProvider>
        <AutoLogout />
        <div className={`${os} dodigitals-body`}>
    
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/Card" element={<Card />} />
              <Route path="/login" element={<Login />} />
              <Route path="/Organization-Registration" element={<Registration />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="/Basic-Information" element={<Basicinformation />} />
              <Route path="/Your-Profession" element={<Yourprofession />} />
              <Route path="/Location-Wise-Population" element={<Locationwisepopulation />} />
              <Route path="/Enhance-Transparency" element={<Enhancetransparency />} />

              {/* admin Route */}

              <Route element={<ProtectedRoute />}>
                <Route path="/Registration-Organization" element={<Organizationregister />} />
                <Route path="/Organization-Dashboard" element={<Dashboard />} />
              </Route>

              {/* admin Route */}
              </Routes>
              </main>
      
        </div>
        <AutoClearLocalStorage />
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
